// Tipos e helpers COMPARTILHADOS da roteirização (determinísticos, rodam no aparelho).
// O motor de 1 dia (`generateSmartRoute`, modos Padrão/Pulverização Casa) morava aqui e foi
// APOSENTADO em 29/08/2026 junto com a tela dele — o Roteiro da Semana o substituiu. Sobrou o que
// os dois sempre dividiram e o motor semanal (`smartWeekRoute.ts`) continua usando: geometria,
// conversão de horário, `cicloDe` (cadência por estrelas) e os tipos LatLng/SmartStop.
// Está no histórico do git se um dia a rota de 1 dia voltar a fazer sentido.

import { RoteirizacaoSettings } from '../types';

export interface LatLng { lat: number; lng: number; }

export interface SmartStop {
  ordem: number;
  clientId: string;
  codparc?: string | number | null;
  nome: string;
  municipio: string;
  bairro: string;
  lat: number;
  lng: number;
  chegada: string;            // HH:MM
  saida: string;              // HH:MM
  duracaoMin: number;
  deslocamentoMin: number;    // tempo de deslocamento até esta parada
  rede: boolean;
  estrelas: number;
  diasAtraso: number;         // dias além do ciclo (0 se ainda no ciclo)
  // 'remarcado' = o vendedor mandou este cliente para este dia à mão (ver a passagem ZERO do
  // `montarDia`). Precisa ser um motivo próprio, e não 'vencido', porque a tela pinta a parada pela
  // cor do motivo — e "eu escolhi que fosse hoje" não é a mesma informação que "está vencido".
  motivo: 'rede_obrigatoria' | 'vencido' | 'vencendo_no_caminho' | 'preenchimento' | 'remarcado';
}

// ----- helpers de tempo -----
export const hhmmToMin = (s: string): number => {
  const [h, m] = (s || '0:0').split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};
export const minToHHMM = (min: number): string => {
  const m = Math.max(0, Math.round(min));
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
};

// ----- geografia -----
const R = 6371;
// FORA da função de propósito. `haversineKm` é a função mais chamada do app: só o k-means do Roteiro
// da Semana faz ~656 mil chamadas numa carteira de 1.600 clientes, e declarar a closure aqui dentro
// criava uma por chamada.
// ⚠️ Honestidade sobre o ganho: no V8 do desktop isto NÃO mudou nada (medido: 87 ms → 87 ms em 1,1
// milhão de chamadas) — a análise de escape já descartava a closure. Mantido porque o Hermes, que é o
// motor do aparelho do vendedor, não tem essa otimização, e porque não custa nada.
// A conta não mudou: continua `(d * Math.PI) / 180`, nesta ordem (`d * (Math.PI/180)` daria outro
// resultado no último bit, e o motor sempre usou esta forma).
const toRad = (d: number) => (d * Math.PI) / 180;
export function haversineKm(a: LatLng, b: LatLng): number {
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const s = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
}

export const semAcento = (s: string) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

export function cicloDe(estrelas: number, s: RoteirizacaoSettings): number | null {
  if (estrelas >= 3) return s.ciclo3Dias;
  if (estrelas === 2) return s.ciclo2Dias;
  if (estrelas === 1) return s.ciclo1Dias;
  return null; // 0★
}
